import { Component } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { CommonQuestionSimpleComponent } from '@kv-common-components/kv-common-components';
@Component({
    selector: 'app-question-simple-component',
    templateUrl: './question-simple.component.html',
    styleUrls: ['./question-simple.component.css'],
})
export class QuestionSimpleComponent extends CommonQuestionSimpleComponent {
    constructor(protected logger: NGXLogger) {
        super(logger);
    }
}
